<template>
    <div class="menu-actions">
        <span v-for="(item, key) in items"
            :key="item.code || key"
            class="menu-actions__link"
            :class="{disabled: item.disabled}"
            @click="handleClick(item)"
            href="item.link">
            {{ item.name }}
        </span>
    </div>
</template>

<script>
import get from 'lodash/get';

export default {
    name: 'MenuActions',
    props: {
        items: {
            type: Array,
            default: () => []
        },
        visible: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            showMenuMore: false
        }
    },
    methods: {
        handleClick(item) {

            if(item.disabled)
                return

            if(item.action) {
                this.$authEmit(item.action, get(item, 'value', ''))
            }
            else if(item.eventName){
                this.$authEmit(item.eventName, get(item, 'value', ''))
            }
            else if(item.link) {
                this.$router.push(item.link)
            }
        }
    }
}
</script>

<style lang="less">
.menu-actions {
    background: @color-white;
    box-shadow: @menu-desktop-box-shadow;

    padding: rem(4) 0;

    width: rem(249);

    visibility: hidden;
    opacity: 0;

    .animate(opacity, 0.2s);

    &[data-visible="true"] {
        visibility: visible;
        opacity: 1;
    }

    &__link {
        display: block;
        color: @color-gray-light;
        padding: rem(12) rem(20);
        width: 100%;
        cursor: default;

        &:not(.disabled){
            color: @color-black;
            cursor: pointer;
            
            &:hover {
                background: @color-gray-light-2;
            }
        }
    }
}
</style>
